import { render, staticRenderFns } from "./InputOpcionaisEvento.vue?vue&type=template&id=5b939d2c&scoped=true"
import script from "./InputOpcionaisEvento.vue?vue&type=script&lang=js"
export * from "./InputOpcionaisEvento.vue?vue&type=script&lang=js"
import style0 from "./InputOpcionaisEvento.vue?vue&type=style&index=0&id=5b939d2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b939d2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b939d2c')) {
      api.createRecord('5b939d2c', component.options)
    } else {
      api.reload('5b939d2c', component.options)
    }
    module.hot.accept("./InputOpcionaisEvento.vue?vue&type=template&id=5b939d2c&scoped=true", function () {
      api.rerender('5b939d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components-evento/InputOpcionaisEvento.vue"
export default component.exports